import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  width: 75%;
  padding-bottom: 20rem;

  & > button > div {
    justify-content: space-between;
  }

  & > p {
    margin-bottom: 1.7rem;
  }
`;
